// Editable content for the Founder Series registration page.
//
// Reason: the developer brief marks the session title and the hero content points as "still to be
// confirmed by our partner — build so they can be edited without a redeploy". The defaults below
// are what ships in the bundle; at runtime the page fetches OVERRIDE_URL and shallow-merges
// anything it finds over them. That file is a plain static asset in the deployed frontend, so
// copy is changed by editing one JSON and invalidating CloudFront — no rebuild, no release.
//
// The joining link lives here for the same reason: it is not known at build time, and the
// on-page confirmation has to show it the moment someone registers.

export const OVERRIDE_URL = '/downloads/founder-series-content.json';

// Hosted calendar file. Must be served as Content-Type: text/calendar — see the developer brief.
export const CALENDAR_URL = '/downloads/founder-series-session-1.ics';

export const DEFAULT_CONTENT = {
    sessionTitle: 'The Ten Transaction Mistakes That Can Stall Your Raise or Exit',
    heroSubtitle: 'A 45-minute live session with Neil Foster (Co-Chair, Global Technology Group, Brown Rudnick), chaired by Paul Morris (Ex-Head of Growth Advisory, BDO). Attendees get free access to the transaction-readiness checklist by Diligentsia.',
    heroAudience: 'Founders, investors and seasoned advisors, in one room.',
    sessionDate: 'Friday 11 September',
    sessionTime: '12:00–12:45 BST',
    session2Title: "Series A Term Sheets: What's Negotiable and What Isn't",
    session3Title: 'What Changes When Investors Join Your Board',
    // Replaced by the override file once Jignesh supplies the real joining link.
    joiningLink: '',
};

/**
 * Fetch the hosted content override and merge it over the defaults.
 * Any failure — missing file, bad JSON, offline — falls back to the bundled copy silently.
 *
 * @returns {Promise<object>} the resolved content object
 */
export const loadWebinarContent = async () => {
    try {
        const res = await fetch(OVERRIDE_URL, { cache: 'no-cache' });
        if (!res.ok) return DEFAULT_CONTENT;
        const override = await res.json();
        return { ...DEFAULT_CONTENT, ...override };
    } catch (error) {
        return DEFAULT_CONTENT;
    }
};
